const PickMealsBanner = ({ selectedMenuClosed }) => {
  return (
    <div className="w-full bp1:block">
      <div className="alert h-24 w-full bg-tempo-green-100 text-white-100">
        <div className="alert__content">
          <h5 className="text self-center">
            {selectedMenuClosed
              ? 'Our menu rotates weekly. Pick meals to get your first box!'
              : "Like what you see? You're just a few steps away from getting easy, wholesome meals delivered to your door."}
          </h5>
        </div>
      </div>
    </div>
  );
};

PickMealsBanner.propTypes = {
  selectedMenuClosed: PropTypes.bool.isRequired,
};

export default PickMealsBanner;
